"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Marketplace = /** @class */ (function () {
    function Marketplace() {
    }
    return Marketplace;
}());
exports.Marketplace = Marketplace;
